// AUTO-GENERATED by scripts/vendor-central-icons.mjs — do not edit by hand.
// Central Icons vendored as local source (no npm package / license gate).
// Line variant: square-outlined-radius-0-stroke-2
// Fill variant: square-filled-radius-0-stroke-2
// Bare `IconFoo` = the Line (outlined) shape; `IconFooFill` = the Fill
// (solid) shape. Requires a Central license to use.
import { createSvgIcon } from './createSvgIcon';

export const IconAnalytics = createSvgIcon(
  <>
    <path
      d="M4 12H8L10 15.5L14 8.5L16 12H20M4 4H20V20H4V4Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
  </>,
  'IconAnalytics'
);

export const IconArrowBoxLeft = createSvgIcon(
  <>
    <path
      d="M11 20H4L4 4L11 4M9 12H19M15.5 16.5L20 12L15.5 7.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
  </>,
  'IconArrowBoxLeft'
);

export const IconArrowDownWall = createSvgIcon(
  <>
    <path
      d="M16.25 15.75L12 20L7.75 15.75"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M19 4L5 4"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M12 8V19"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
  </>,
  'IconArrowDownWall'
);

export const IconArrowLeft = createSvgIcon(
  <>
    <path
      d="M10 6L4 12L10 18"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M5 12H20"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
  </>,
  'IconArrowLeft'
);

export const IconArrowRightSquare = createSvgIcon(
  <>
    <path d="M20 4H4V20H20V4Z" stroke="currentColor" strokeWidth="2" />
    <path
      d="M13 9L16 12L13 15"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M8 12H15"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </>,
  'IconArrowRightSquare'
);

export const IconArrowRotateClockwise = createSvgIcon(
  <>
    <path
      d="M18.9297 8C17.5465 5.60879 14.9611 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C15.7277 20 18.8599 17.4505 19.748 14"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path d="M19 3V8H14" stroke="currentColor" strokeWidth="2" />
  </>,
  'IconArrowRotateClockwise'
);

export const IconArrowRotateCounterClockwise = createSvgIcon(
  <>
    <path
      d="M4.4834 14.6667C5.58163 17.7738 8.54493 20 12.0282 20C16.4465 20 20.0282 16.4183 20.0282 12C20.0282 7.58172 16.4465 4 12.0282 4C9.37043 4 7.57017 5.10544 5.8485 7"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M5 4V8H9"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
  </>,
  'IconArrowRotateCounterClockwise'
);

export const IconArrowUpRight = createSvgIcon(
  <>
    <path
      d="M18 15V6H9"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M6.25 17.75L17 7"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
  </>,
  'IconArrowUpRight'
);

export const IconArrowUpWall = createSvgIcon(
  <>
    <path
      d="M16.25 8L12 3.75L7.75 8"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M19 20L5 20"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M12 5V16"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
  </>,
  'IconArrowUpWall'
);

export const IconBarsThree = createSvgIcon(
  <>
    <path
      d="M3 12H21M3 6H21M3 18H21"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
  </>,
  'IconBarsThree'
);

export const IconBell = createSvgIcon(
  <>
    <path
      d="M4.80754 9.46301C5.20136 5.78731 8.30327 3 12 3C15.6967 3 18.7986 5.78732 19.1925 9.46301L20 17H4L4.80754 9.46301Z"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M16 17C16 19.2091 14.2091 21 12 21C9.79086 21 8 19.2091 8 17"
      stroke="currentColor"
      strokeWidth="2"
    />
  </>,
  'IconBell'
);

export const IconBell2 = createSvgIcon(
  <>
    <path
      d="M20 17H4V16L5.5 13L5.70037 8.99251C5.86822 5.63561 8.6389 3 12 3C15.3611 3 18.1318 5.63561 18.2996 8.99251L18.5 13L20 16V17Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M8.03094 17.5C8.27699 19.4732 9.96019 21 12 21C14.0398 21 15.723 19.4732 15.9691 17.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
  </>,
  'IconBell2'
);

export const IconBookmarkCheck = createSvgIcon(
  <>
    <path
      d="M19 21V3H5V21L12 17L19 21Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M9.5 10.25L11 11.75L14.5 8.25"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
  </>,
  'IconBookmarkCheck'
);

export const IconBookmarkPlus = createSvgIcon(
  <>
    <path
      d="M19 21V3H5V21L12 17L19 21Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M12 7V13"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M15 10L9 10"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
  </>,
  'IconBookmarkPlus'
);

export const IconBubbleDots = createSvgIcon(
  <>
    <path
      d="M4.00195 4.00003L20.002 4V18.0357L15.0153 18.0358L11.9977 20.5358L9.01526 18.0358H4.00195V4.00003Z"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M6.875 11.25C6.875 11.7332 7.26675 12.125 7.75 12.125C8.23325 12.125 8.625 11.7332 8.625 11.25C8.625 10.7668 8.23325 10.375 7.75 10.375C7.26675 10.375 6.875 10.7668 6.875 11.25ZM11.125 11.25C11.125 11.7332 11.5168 12.125 12 12.125C12.4832 12.125 12.875 11.7332 12.875 11.25C12.875 10.7668 12.4832 10.375 12 10.375C11.5168 10.375 11.125 10.7668 11.125 11.25ZM15.375 11.25C15.375 11.7332 15.7668 12.125 16.25 12.125C16.7332 12.125 17.125 11.7332 17.125 11.25C17.125 10.7668 16.7332 10.375 16.25 10.375C15.7668 10.375 15.375 10.7668 15.375 11.25Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.75"
      strokeLinecap="square"
    />
  </>,
  'IconBubbleDots'
);

export const IconBubblePlus = createSvgIcon(
  <>
    <path
      d="M11.9998 8.00003L11.9998 11M11.9998 11V14M11.9998 11H8.99976M11.9998 11H14.9998M4.00195 4.00003L20.002 4V18.0357L15.0153 18.0358L11.9977 20.5358L9.01526 18.0358H4.00195V4.00003Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
  </>,
  'IconBubblePlus'
);

export const IconBubbleText = createSvgIcon(
  <>
    <path
      d="M14.9998 9H8.99976M14.9998 13H8.99976M4.00195 4.00003L20.002 4V18.0357L15.0153 18.0358L11.9977 20.5358L9.01526 18.0358H4.00195V4.00003Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
  </>,
  'IconBubbleText'
);

export const IconBubbleText6 = createSvgIcon(
  <>
    <path
      d="M15 10H9M12 14H9M3 20H16C18.7614 20 21 17.7614 21 15V9C21 6.23858 18.7614 4 16 4H8C5.23858 4 3 6.23858 3 9V20Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
  </>,
  'IconBubbleText6'
);

export const IconBubbles = createSvgIcon(
  <>
    <path
      d="M3.00195 8H17.002V18H10.502L6.00195 20.5V18H3.00195V8Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M16.9998 14H21.002V4H7.00195V8"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
  </>,
  'IconBubbles'
);

export const IconBuildings = createSvgIcon(
  <>
    <path
      d="M22 19H2"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="16"
      strokeLinecap="square"
    />
    <path
      d="M20 19V8H14"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="16"
      strokeLinecap="square"
    />
    <path
      d="M14 19V4H4V19"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="16"
      strokeLinecap="square"
    />
    <path
      d="M10 9H8"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="16"
      strokeLinecap="square"
    />
    <path
      d="M8 13H10"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="16"
      strokeLinecap="square"
    />
  </>,
  'IconBuildings'
);

export const IconCalendar1 = createSvgIcon(
  <>
    <path
      d="M4 5H20V20H4V5Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M4 10H20"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M8 5V3"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M16 5V3"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </>,
  'IconCalendar1'
);

export const IconCalendarCheck = createSvgIcon(
  <>
    <path
      d="M20 5H4V9H20V5Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M20 9V12"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M4 9V20H11"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M8 5V3"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M16 5V3"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M21 16L17 21L15 19"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
  </>,
  'IconCalendarCheck'
);

export const IconCheckmark1 = createSvgIcon(
  <>
    <path
      d="M5 12.75L10 19L19 5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
  </>,
  'IconCheckmark1'
);

export const IconChevronDownSmall = createSvgIcon(
  <>
    <path
      d="M8 10L12 14L16 10"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
  </>,
  'IconChevronDownSmall'
);

export const IconChevronLeft = createSvgIcon(
  <>
    <path d="M15 20L7 12L15 4" stroke="currentColor" strokeWidth="2" />
  </>,
  'IconChevronLeft'
);

export const IconChevronRight = createSvgIcon(
  <>
    <path d="M9 4L17 12L9 20" stroke="currentColor" strokeWidth="2" />
  </>,
  'IconChevronRight'
);

export const IconChevronTop = createSvgIcon(
  <>
    <path d="M4 15L12 7L20 15" stroke="currentColor" strokeWidth="2" />
  </>,
  'IconChevronTop'
);

export const IconCircleCheck = createSvgIcon(
  <>
    <path
      d="M15 9.5L10.5 15L8.5 13M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
  </>,
  'IconCircleCheck'
);

export const IconCircleInfo = createSvgIcon(
  <>
    <path
      d="M11 11H12V16M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M11.5 7.25H11.25V7.5V8.5V8.75H11.5H12.5H12.75V8.5V7.5V7.25H12.5H11.5Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.5"
    />
  </>,
  'IconCircleInfo'
);

export const IconCircleX = createSvgIcon(
  <>
    <path
      d="M15 9L9 15M15 15L9 9M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
  </>,
  'IconCircleX'
);

export const IconClipboard = createSvgIcon(
  <>
    <path
      d="M15 5H19V21H5V5H9M9 3H15V7H9V3Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
  </>,
  'IconClipboard'
);

export const IconCloudUpload = createSvgIcon(
  <>
    <path
      d="M14.5 14.5L12 12L9.5 14.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M8 19H7C4.23858 19 2 16.7614 2 14C2 11.4673 3.88316 9.37436 6.32568 9.04508C7.13649 6.69118 9.37075 5 12 5C15.3137 5 18 7.68629 18 11C20.2091 11 22 12.7909 22 15C22 17.2091 20.2091 19 18 19H16"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M12 19V13"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
  </>,
  'IconCloudUpload'
);

export const IconCreditCard2 = createSvgIcon(
  <>
    <path
      d="M3 10V19H21V10M3 10V5H21V10M3 10H21M7 14H10"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
  </>,
  'IconCreditCard2'
);

export const IconCrossSmall = createSvgIcon(
  <>
    <path
      d="M8 8L16 16M16 8L8 16"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
  </>,
  'IconCrossSmall'
);

export const IconDotGrid1x3Horizontal = createSvgIcon(
  <>
    <path d="M3 11H5V13H3V11Z" stroke="currentColor" strokeWidth="2" />
    <path d="M13 11H11V13H13V11Z" stroke="currentColor" strokeWidth="2" />
    <path d="M19 11H21V13H19V11Z" stroke="currentColor" strokeWidth="2" />
  </>,
  'IconDotGrid1x3Horizontal'
);

export const IconDotGrid1x3Vertical = createSvgIcon(
  <>
    <path d="M11 3H13V5H11V3Z" stroke="currentColor" strokeWidth="2" />
    <path d="M13 11H11V13H13V11Z" stroke="currentColor" strokeWidth="2" />
    <path d="M11 19H13V21H11V19Z" stroke="currentColor" strokeWidth="2" />
  </>,
  'IconDotGrid1x3Vertical'
);

export const IconEmail1 = createSvgIcon(
  <>
    <path
      d="M21 5H22V4H21V5ZM21 19V20H22V19H21ZM3 5V4H2V5H3ZM3 19H2V20H3V19ZM21 5H20V19H21H22V5H21ZM3 5V6H21V5V4H3V5ZM3 19H4V5H3H2V19H3ZM21 19V18H3V19V20H21V19Z"
      fill="currentColor"
    />
    <path
      d="M3.5 6.04547L12 13L20.5 6.04547"
      stroke="currentColor"
      strokeWidth="2"
    />
  </>,
  'IconEmail1'
);

export const IconExclamationCircle = createSvgIcon(
  <>
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" />
    <path d="M12 7.5V13" stroke="currentColor" strokeWidth="2" />
    <circle cx="12" cy="15.7" r="1.2" fill="currentColor" />
  </>,
  'IconExclamationCircle'
);

export const IconExclamationTriangle = createSvgIcon(
  <>
    <path
      d="M12 16V15.99M12 10V13M12 3L2.5 19H21.5L12 3Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
  </>,
  'IconExclamationTriangle'
);

export const IconEyeOpen = createSvgIcon(
  <>
    <path
      d="M2 12.0001C6.82745 2.66678 17.1725 2.66667 22 12C17.1725 21.3333 6.82745 21.3334 2 12.0001Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  'IconEyeOpen'
);

export const IconFileText = createSvgIcon(
  <>
    <path
      d="M5 3H13L19 9V21H5V3Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M9 13H12"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M9 17H15.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M13 4V9H18"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
  </>,
  'IconFileText'
);

export const IconFingerPrint1 = createSvgIcon(
  <>
    <path
      d="M15.0502 18.399L14.0831 18.1446L15.0502 18.399ZM13.4008 20.3585L13.0666 21.301L14.9517 21.9693L15.2858 21.0268L13.4008 20.3585ZM18.4645 16.8758L18.2821 17.8591L20.2485 18.2239L20.431 17.2407L18.4645 16.8758ZM2.55166 14.7886L2.31576 15.7604L4.25932 16.2322L4.49522 15.2604L2.55166 14.7886ZM13.003 11V10H11.003V11H13.003ZM10.7295 18.8992L9.78061 18.5834V18.5834L10.7295 18.8992ZM9.09741 20.3887L8.70588 21.3089L10.5462 22.092L10.9377 21.1718L9.09741 20.3887ZM5.48165 18.6645L5.09814 19.5881L6.94522 20.3551L7.32872 19.4316L5.48165 18.6645ZM12.0026 4C15.8686 4 19.0026 7.13401 19.0026 11H21.0026C21.0026 6.02944 16.9732 2 12.0026 2V4ZM9.00262 11C9.00262 9.34315 10.3458 8 12.0026 8V6C9.2412 6 7.00262 8.23858 7.00262 11H9.00262ZM12.0026 8C13.6595 8 15.0026 9.34315 15.0026 11H17.0026C17.0026 8.23858 14.764 6 12.0026 6V8ZM14.0831 18.1446C13.8856 18.8954 13.6577 19.6338 13.4008 20.3585L15.2858 21.0268C15.5612 20.2499 15.8056 19.4583 16.0173 18.6535L14.0831 18.1446ZM19.0026 11C19.0026 13.0079 18.8178 14.9718 18.4645 16.8758L20.431 17.2407C20.8065 15.217 21.0026 13.1309 21.0026 11H19.0026ZM3.00262 11C3.00262 12.3065 2.84625 13.575 2.55166 14.7886L4.49522 15.2604C4.82701 13.8935 5.00262 12.4666 5.00262 11H3.00262ZM8.9401 4.70346C9.86397 4.25315 10.9023 4 12.0026 4V2C10.5921 2 9.25467 2.32521 8.06381 2.90565L8.9401 4.70346ZM5.00262 11C5.00262 9.13543 5.73032 7.44297 6.91919 6.18762L5.46705 4.81238C3.94043 6.42436 3.00262 8.60374 3.00262 11H5.00262ZM14.588 15.8288C14.4518 16.6124 14.283 17.3849 14.0831 18.1446L16.0173 18.6535C16.2316 17.839 16.4125 17.0111 16.5584 16.1712L14.588 15.8288ZM15.0026 11C15.0026 11.9788 14.9524 12.9455 14.8546 13.8978L16.8441 14.1022C16.9489 13.0821 17.0026 12.0472 17.0026 11H15.0026ZM11.003 11C11.003 13.6517 10.5734 16.2011 9.78061 18.5834L11.6783 19.2149C12.538 16.6315 13.003 13.8691 13.003 11H11.003ZM9.78061 18.5834C9.57658 19.1966 9.34848 19.7987 9.09741 20.3887L10.9377 21.1718C11.2099 20.5323 11.4571 19.8796 11.6783 19.2149L9.78061 18.5834ZM7.00262 11C7.00262 12.7157 6.78682 14.3795 6.38139 15.9664L8.31916 16.4615C8.76557 14.7141 9.00262 12.884 9.00262 11H7.00262ZM5.96434 17.3782C5.81786 17.8139 5.65677 18.2428 5.48165 18.6645L7.32872 19.4316C7.52147 18.9674 7.69879 18.4952 7.86005 18.0156L5.96434 17.3782Z"
      fill="currentColor"
    />
  </>,
  'IconFingerPrint1'
);

export const IconGlobe = createSvgIcon(
  <>
    <path
      d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M12 21C10.067 21 8.5 16.9706 8.5 12C8.5 7.02944 10.067 3 12 3C13.933 3 15.5 7.02944 15.5 12C15.5 16.9706 13.933 21 12 21Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M21 12H3"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
  </>,
  'IconGlobe'
);

export const IconHome = createSvgIcon(
  <>
    <path d="M4 9L12 2.5L20 9V20H4V9Z" stroke="currentColor" strokeWidth="2" />
  </>,
  'IconHome'
);

export const IconLayoutRight = createSvgIcon(
  <>
    <path d="M4 4L16 4L16 20H4L4 4Z" stroke="currentColor" strokeWidth="2" />
    <path d="M20 3V21" stroke="currentColor" strokeWidth="2" />
  </>,
  'IconLayoutRight'
);

export const IconLineChart1 = createSvgIcon(
  <>
    <path
      d="M9 11V16M14 5V16M19 13V16M4 4V20H21"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
  </>,
  'IconLineChart1'
);

export const IconListBullets = createSvgIcon(
  <>
    <path d="M9 6L21 6" stroke="currentColor" strokeWidth="2" />
    <circle cx="4.5" cy="6" r="1.5" fill="currentColor" />
    <path d="M9 12L21 12" stroke="currentColor" strokeWidth="2" />
    <circle cx="4.5" cy="12" r="1.5" fill="currentColor" />
    <path d="M9 18L21 18" stroke="currentColor" strokeWidth="2" />
    <circle cx="4.5" cy="18" r="1.5" fill="currentColor" />
  </>,
  'IconListBullets'
);

export const IconLoadingCircle = createSvgIcon(
  <>
    <path
      d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
      stroke="currentColor"
      strokeOpacity="0.3"
      strokeWidth="2"
    />
    <path
      d="M21 12C21 16.9706 16.9706 21 12 21"
      stroke="currentColor"
      strokeWidth="2"
    />
  </>,
  'IconLoadingCircle'
);

export const IconMagnifyingGlass = createSvgIcon(
  <>
    <path
      d="M11 18C14.866 18 18 14.866 18 11C18 7.13401 14.866 4 11 4C7.13401 4 4 7.13401 4 11C4 14.866 7.13401 18 11 18Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M20 20L16.05 16.05"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
  </>,
  'IconMagnifyingGlass'
);

export const IconMapPin = createSvgIcon(
  <>
    <path
      d="M14.4978 10C14.4978 11.3807 13.3785 12.5 11.9978 12.5C10.6171 12.5 9.4978 11.3807 9.4978 10C9.4978 8.61929 10.6171 7.5 11.9978 7.5C13.3785 7.5 14.4978 8.61929 14.4978 10Z"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M19 10C19 15.866 12 21 12 21C12 21 5 15.866 5 10C5 6.13401 8.13401 3 12 3C15.866 3 19 6.13401 19 10Z"
      stroke="currentColor"
      strokeWidth="2"
    />
  </>,
  'IconMapPin'
);

export const IconMapPin2 = createSvgIcon(
  <>
    <path
      d="M19.2008 10.2C19.2008 6.22355 15.9772 3 12.0008 3C8.02433 3 4.80078 6.22355 4.80078 10.2C4.80078 14.5076 9.79854 17.5424 11.501 21H12.501C14.2034 17.5424 19.2008 14.5076 19.2008 10.2Z"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M9 10.2001C9 8.54322 10.3431 7.20007 12 7.20007C13.6569 7.20007 15 8.54322 15 10.2001C15 11.8569 13.6569 13.2001 12 13.2001C10.3431 13.2001 9 11.8569 9 10.2001Z"
      stroke="currentColor"
      strokeWidth="2"
    />
  </>,
  'IconMapPin2'
);

export const IconMinusMedium = createSvgIcon(
  <>
    <path
      d="M5.5 12H18.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
  </>,
  'IconMinusMedium'
);

export const IconPageCheck = createSvgIcon(
  <>
    <path
      d="M9 21H5V3H19V10"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M13.5 19L15.5 21.0002L20.5 15"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
  </>,
  'IconPageCheck'
);

export const IconPaperclip1 = createSvgIcon(
  <>
    <path
      d="M6 11V15C6 18.3137 8.68629 21 12 21C15.3137 21 18 18.3137 18 15V7C18 4.79086 16.2091 3 14 3C11.7909 3 10 4.79086 10 7V15C10 16.1046 10.8954 17 12 17C13.1046 17 14 16.1046 14 15V8"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
  </>,
  'IconPaperclip1'
);

export const IconPencil = createSvgIcon(
  <>
    <path
      d="M13.5 6L16.5 3L21 7.5L18 10.5L7.5 21H3V16.5L13.5 6Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M13.5 6L18 10.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </>,
  'IconPencil'
);

export const IconPeopleAdd = createSvgIcon(
  <>
    <path
      d="M15.5 6.5C15.5 8.433 13.933 10 12 10C10.067 10 8.5 8.433 8.5 6.5C8.5 4.567 10.067 3 12 3C13.933 3 15.5 4.567 15.5 6.5Z"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M15 13.588C14.1006 13.2092 13.0928 13 12 13C7.8098 13 4.86894 16.0754 4.5 20H12"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="16"
    />
    <path
      d="M18 14V18M18 18V22M18 18H14M18 18H22"
      stroke="currentColor"
      strokeWidth="2"
    />
  </>,
  'IconPeopleAdd'
);

export const IconPeopleCircle = createSvgIcon(
  <>
    <path
      d="M21 12C21 14.721 19.7925 17.16 17.8841 18.8103C16.3063 20.1747 14.2495 21 12 21C9.75046 21 7.69368 20.1747 6.11594 18.8103C4.20753 17.16 3 14.721 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M15 10C15 11.6569 13.6569 13 12 13C10.3431 13 9 11.6569 9 10C9 8.34315 10.3431 7 12 7C13.6569 7 15 8.34315 15 10Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M16.7618 19.0287L17.4364 19.7669L18.9128 18.4176L18.2382 17.6795L16.7618 19.0287ZM6.5 18.3541L7.23817 19.0287C8.37439 17.7854 10.0096 17 12 17V16V15C9.45012 15 7.27843 16.02 5.76183 17.6795L6.5 18.3541ZM12 16V17C13.9904 17 15.6256 17.7854 16.7618 19.0287L17.5 18.3541L18.2382 17.6795C16.7216 16.02 14.5499 15 12 15V16Z"
      fill="currentColor"
    />
  </>,
  'IconPeopleCircle'
);

export const IconPhone = createSvgIcon(
  <>
    <path
      d="M10 19H14M6 2H18V22H6V2Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
  </>,
  'IconPhone'
);

export const IconPlusMedium = createSvgIcon(
  <>
    <path
      d="M12 5.5V12M12 12V18.5M12 12H5.5M12 12H18.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
  </>,
  'IconPlusMedium'
);

export const IconReceiptBill = createSvgIcon(
  <>
    <path
      d="M9 8H15M9 12H11M5 3H19V20.6L16.6667 19L14.3333 21L12 19L9.66667 21L7.33333 19L5 20.6V3Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
  </>,
  'IconReceiptBill'
);

export const IconRecord = createSvgIcon(
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z"
      fill="currentColor"
    />
    <path
      d="M16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12Z"
      fill="currentColor"
    />
  </>,
  'IconRecord'
);

export const IconSend = createSvgIcon(
  <>
    <path
      d="M14 20.25L20 4L3.75 10L11 13L14 20.25Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </>,
  'IconSend'
);

export const IconServer = createSvgIcon(
  <>
    <path
      d="M3 5H21V12H3V5Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M3 12H21V19H3V12Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M6.5 14.625C6.98325 14.625 7.375 15.0168 7.375 15.5C7.375 15.9832 6.98325 16.375 6.5 16.375C6.01675 16.375 5.625 15.9832 5.625 15.5C5.625 15.0168 6.01675 14.625 6.5 14.625ZM6.5 7.625C6.98325 7.625 7.375 8.01675 7.375 8.5C7.375 8.98325 6.98325 9.375 6.5 9.375C6.01675 9.375 5.625 8.98325 5.625 8.5C5.625 8.01675 6.01675 7.625 6.5 7.625Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.75"
    />
  </>,
  'IconServer'
);

export const IconShareAndroid = createSvgIcon(
  <>
    <path
      d="M14.3354 7.37976C14.8349 8.34235 15.8406 9 17 9C18.6569 9 20 7.65685 20 6C20 4.34315 18.6569 3 17 3C15.3431 3 14 4.34315 14 6C14 6.49749 14.1211 6.9667 14.3354 7.37976ZM14.3354 7.37976L8.66458 10.6202M8.66458 10.6202C8.16512 9.65765 7.15936 9 6 9C4.34315 9 3 10.3431 3 12C3 13.6569 4.34315 15 6 15C7.15936 15 8.16512 14.3424 8.66458 13.3798M8.66458 10.6202C8.8789 11.0333 9 11.5025 9 12C9 12.4975 8.8789 12.9667 8.66458 13.3798M8.66458 13.3798L14.3354 16.6202M14.3354 16.6202C14.1211 17.0333 14 17.5025 14 18C14 19.6569 15.3431 21 17 21C18.6569 21 20 19.6569 20 18C20 16.3431 18.6569 15 17 15C15.8406 15 14.8349 15.6576 14.3354 16.6202Z"
      stroke="currentColor"
      strokeWidth="2"
    />
  </>,
  'IconShareAndroid'
);

export const IconShoppingBag3 = createSvgIcon(
  <>
    <path
      d="M8 11V4H16V11M4 8H20V20H4V8Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
  </>,
  'IconShoppingBag3'
);

export const IconSquareCheck = createSvgIcon(
  <>
    <path
      d="M20 4H21V3H20V4ZM20 20V21H21V20H20ZM4.00002 20H3.00002V21H4.00002V20ZM4.00002 4V3H3.00002V4H4.00002ZM10.9968 14.25L10.2897 14.9571L10.9968 15.6642L11.7039 14.9571L10.9968 14.25ZM16.2039 10.4571L16.911 9.75001L15.4968 8.3358L14.7897 9.0429L16.2039 10.4571ZM9.70388 11.5429L8.99678 10.8358L7.58256 12.25L8.28967 12.9571L9.70388 11.5429ZM19 4V20H21V4H19ZM20 19H4.00002V21H20V19ZM5.00002 20V4H3.00002V20H5.00002ZM4.00002 5H20V3H4.00002V5ZM11.7039 14.9571L16.2039 10.4571L14.7897 9.0429L10.2897 13.5429L11.7039 14.9571ZM8.28967 12.9571L10.2897 14.9571L11.7039 13.5429L9.70388 11.5429L8.28967 12.9571Z"
      fill="currentColor"
    />
  </>,
  'IconSquareCheck'
);

export const IconTrashCan = createSvgIcon(
  <>
    <path
      d="M5 6.5L6 21H18L19 6.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M10 11V16"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M14 11V16"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M3.5 6H20.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M8.07092 5.74621C8.42347 3.89745 10.0485 2.5 12 2.5C13.9515 2.5 15.5765 3.89745 15.9291 5.74621"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
  </>,
  'IconTrashCan'
);

export const IconTrashCanSimple = createSvgIcon(
  <>
    <path
      d="M5 6.5L6 21H18L19 6.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M3.5 6H20.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M8.07092 5.74621C8.42347 3.89745 10.0485 2.5 12 2.5C13.9515 2.5 15.5765 3.89745 15.9291 5.74621"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
  </>,
  'IconTrashCanSimple'
);

export const IconTrending5 = createSvgIcon(
  <>
    <path
      d="M19 11L17 9L12 14L9.5 11.5L4.5 16.5M4 4V20H20"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
  </>,
  'IconTrending5'
);

export const IconUser = createSvgIcon(
  <>
    <path
      d="M5 20V19C5 15.134 8.13401 12 12 12C15.866 12 19 15.134 19 19V20H5Z"
      stroke="currentColor"
      strokeWidth="2"
    />
    <circle cx="12" cy="7.75" r="4.25" stroke="currentColor" strokeWidth="2" />
  </>,
  'IconUser'
);

export const IconUserGroup = createSvgIcon(
  <>
    <circle cx="12" cy="9" r="3" stroke="currentColor" strokeWidth="2" />
    <circle cx="4" cy="9.5" r="2" stroke="currentColor" strokeWidth="2" />
    <circle cx="20" cy="9.5" r="2" stroke="currentColor" strokeWidth="2" />
    <path
      d="M7.5 18V16.5C7.5 14.0147 9.51472 12 12 12C14.4853 12 16.5 14.0147 16.5 16.5V18H7.5Z"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M5 16.9999H1C1 14.4999 1.77328 12.7017 4 11.5698"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M19 17H23C23 14.4999 22.2267 12.7018 20 11.5699"
      stroke="currentColor"
      strokeWidth="2"
    />
  </>,
  'IconUserGroup'
);

export const IconX = createSvgIcon(
  <>
    <path
      d="M17.5652 3.25H20.5319L14.0505 10.6628L21.6753 20.75H15.7052L11.0291 14.6322L5.67867 20.75H2.71017L9.64264 12.8212L2.32812 3.25H8.44986L12.6766 8.84192L17.5652 3.25ZM16.524 18.9731H18.1679L7.55662 4.93359H5.79256L16.524 18.9731Z"
      fill="currentColor"
    />
  </>,
  'IconX'
);

export const IconCalendarRemove4 = createSvgIcon(
  <>
    <path
      d="M4 5H20V20H4V5Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M8 5V3"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M16 5V3"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M9.74609 10.25L14.2478 14.7517"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M14.2517 10.25L9.75 14.7517"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </>,
  'IconCalendarRemove4'
);

export const IconBell2Fill = createSvgIcon(
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 2C8.10602 2 4.89608 5.05346 4.70162 8.94258L4.51173 12.7405L3 15.7639V18H7.10002C7.56329 20.2822 9.58104 22 12 22C14.419 22 16.4367 20.2822 16.9 18H21V15.7639L19.4883 12.7405L19.2984 8.94258C19.1039 5.05346 15.894 2 12 2ZM12 20C10.6938 20 9.58254 19.1652 9.17071 18H14.8293C14.4175 19.1652 13.3062 20 12 20Z"
      fill="currentColor"
    />
  </>,
  'IconBell2Fill'
);

export const IconBubblesFill = createSvgIcon(
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.00195 3H22.002V15H18.002V19H10.7611L5.00195 22.1995V19H2.00195V7H6.00195V3ZM8.00195 7H18.002V13H20.002V5H8.00195V7Z"
      fill="currentColor"
    />
  </>,
  'IconBubblesFill'
);

export const IconHomeFill = createSvgIcon(
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 1.21155L21 8.52405V21H3V8.52405L12 1.21155Z"
      fill="currentColor"
    />
  </>,
  'IconHomeFill'
);

export const IconPageCheckFill = createSvgIcon(
  <>
    <path
      d="M20 2H4V22H12.2573L9.25736 18.9997L13.5003 14.7574L15.2985 16.5558L20 11V2Z"
      fill="currentColor"
    />
    <path
      d="M21.9084 14.8719L20.3719 13.5916L15.4328 19.5188L13.5001 17.5858L12.0858 18.9999L15.5672 22.4817L21.9084 14.8719Z"
      fill="currentColor"
    />
  </>,
  'IconPageCheckFill'
);

export const IconPeopleCircleFill = createSvgIcon(
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 2C17.5234 2 22 6.47717 22 12C22 17.5228 17.5234 22 12 22C6.47656 22 2 17.5228 2 12C2 6.47717 6.47656 2 12 2ZM12 15C9.60547 15 7.61719 16.0055 6.28516 17.5996C7.73826 19.081 9.76184 20 12 20C14.2382 20 16.2617 19.081 17.7148 17.5996C16.3828 16.0055 14.3945 15 12 15ZM12 6.75C10.2045 6.75 8.75 8.20509 8.75 10C8.75 11.7949 10.2045 13.25 12 13.25C13.7955 13.25 15.25 11.7949 15.25 10C15.25 8.20509 13.7955 6.75 12 6.75Z"
      fill="currentColor"
    />
  </>,
  'IconPeopleCircleFill'
);

export const IconSquareCheckFill = createSvgIcon(
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 3H21V21H3V3ZM16.911 9.75001L15.4968 8.3358L10.9968 12.8358L8.99676 10.8358L7.58255 12.25L10.9968 15.6642L16.911 9.75001Z"
      fill="currentColor"
    />
  </>,
  'IconSquareCheckFill'
);

export const IconTrending4Fill = createSvgIcon(
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 4V18H22V20H2V4H4ZM14 6H20V12H18V9.41421L13 14.4142L11 12.4142L7 16.4142L5.58579 15L11 9.58579L13 11.5858L16.5858 8H14V6Z"
      fill="currentColor"
    />
  </>,
  'IconTrending4Fill'
);

export const IconClipboardFill = createSvgIcon(
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 2H8V4H4V22H20V4H16V2ZM14 4H10V6H14V4Z"
      fill="currentColor"
    />
  </>,
  'IconClipboardFill'
);
